import React from 'react';
import "../App.css";
import ManufacturingUnit from "../image/ManufacturingUnit.webp";

export default function InfrastructurePage() {
  return (
    <div className="page-wrapper light-section min-vh-100">
      {/* Hero Banner Section */}
      <div className="page-banner position-relative">
        <div className="glowing-orb primary top-50 start-50 translate-middle" style={{ width: '400px', height: '400px', opacity: 0.5 }}></div>
        <div className="container position-relative z-1 text-center">
          <h1 className="page-banner-title text-white">Our Infrastructure</h1>
          <div className="page-banner-breadcrumb text-light opacity-75">
            <a href="/" className="text-light text-decoration-none">Home</a> <span>/</span> Our Infrastructure
          </div>
        </div>
      </div>

      <section className="section-padding light-section">
        <div className="container position-relative z-1">
          <div className="row align-items-center flex-lg-row-reverse mb-0">
            <div className="col-lg-6 mb-4 mb-lg-0 px-3 px-md-4 px-lg-4">
              <div className="about-image-wrapper rounded-4 shadow-lg overflow-hidden position-relative">
                <img src={ManufacturingUnit} alt="Infrastructure" className="img-fluid w-100 h-100 transition-all hover-lift" style={{ objectFit: 'cover', minHeight: '320px' }} />
              </div>
            </div>
            <div className="col-lg-6 px-3 px-md-4 px-lg-4 mt-2 mt-lg-0">
              <span className="section-pill mb-3">State-of-the-art</span>
              <h2 className="section-heading text-dark mb-3 mb-md-4 fs-3 fs-md-2">Manufacturing <span className="text-primary fst-italic">Unit</span></h2>

              <div className="white-card p-3 p-md-4 p-lg-5 rounded-4 shadow-sm border-0">
                <p className="text-muted-dark mb-3 mb-md-4 fs-6" style={{ lineHeight: '1.8' }}>
                  Located in Surat (Gujarat, India), we are supported by a well-functional and highly robust infrastructural unit that assists us in the manufacturing of a wide range of products as per the set industry norms.
                </p>
                <p className="text-muted-dark mb-3 mb-md-4 fs-6" style={{ lineHeight: '1.8' }}>
                  Our infrastructure is carefully segregated into various departments including manufacturing, quality testing, warehousing, and packaging. This allows for a smooth, streamlined workflow and ensures every product that leaves our facility meets our stringent quality standards.
                </p>
                <ul className="list-unstyled mt-3 mt-md-4 text-muted-dark">
                  <li className="mb-2 mb-md-3 d-flex align-items-center"><span className="text-primary me-2 fs-5">✓</span> Advanced Machinery & Tools</li>
                  <li className="mb-2 mb-md-3 d-flex align-items-center"><span className="text-primary me-2 fs-5">✓</span> Experienced Technical Workforce</li>
                  <li className="mb-2 mb-md-3 d-flex align-items-center"><span className="text-primary me-2 fs-5">✓</span> Dedicated Quality Control Division</li>
                  <li className="mb-2 mb-md-3 d-flex align-items-center"><span className="text-primary me-2 fs-5">✓</span> Spacious Warehousing</li>
                </ul>
                <div className="mt-4 mt-md-5">
                  <a href="/collections" className="btn btn-primary rounded-pill px-4 py-2 hover-lift">VIEW OUR PRODUCTS</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
